import * as Yup from "yup";

import { CreateInsurerRep, CreateInsurerRepVariables } from "_graphql/mutation/__generated__/CreateInsurerRep";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

import { InsurerRepForm } from "components/forms";
import { Modal } from "components";
import { createInsurerRep } from "_graphql/visal/mutations/insurer";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const insurerRepValidationSchema = Yup.object().shape({
    rep_first_name: Yup.string().required("First name is required"),
    rep_last_name: Yup.string().required("Last name is required"),
    rep_primary_phonenumber: Yup.string().required("Phone number is required"),
    rep_secondary_phonenumber: Yup.string().notRequired(),
    rep_email: Yup.string().required("Email is required"),
    position: Yup.string().required("Position is required"),
});

export default function CreateInsurerManagerContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useAppSearch();
    const { params } = useAppLocation();
    const [create, { loading }] = useMutation<CreateInsurerRep, CreateInsurerRepVariables>(createInsurerRep, {
        refetchQueries: ["GetInsurerAssociates", "Insurers", "GetInsurerAssociates"],
    });
    const form = useFormik<CreateInsurerRepVariables["insurerRep"]>({
        initialValues: {
            insurersinsurer_id: searchParams?.id || params?.insurer || "",
            rep_first_name: "",
            rep_last_name: "",
            rep_primary_phonenumber: "",
            rep_secondary_phonenumber: "",
            rep_email: "",
            position: "",
        },
        validationSchema: insurerRepValidationSchema,
        onSubmit: async (variables) => {
            await create({
                variables: {
                    insurerRep: variables,
                },
            }).then(({ data }) => {
                if (data?.createInsurerRep.insurer_associate_id) {
                    toast.success("Insurer Representative created successfully");
                    refetch?.();
                    form.resetForm();
                } else {
                    toast.error("Failed to create Insurer Representative");
                }
            });
        },
        onReset: () => {
            setOpen(false);
        },
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="Add New Insurer Representative"
            description="Provide the details to add a new insurer rep"
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={wrapClick(form.handleSubmit)}
                    >
                        {loading ? "Adding Insurer Rep..." : "Add Insurer Rep"}
                    </button>
                </>
            )}
        >
            <InsurerRepForm form={form} />
        </Modal>
    );
}
